"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamJoinForm = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _StreamJoinForm = require("./StreamJoinForm.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StreamJoinForm = exports.StreamJoinForm = function StreamJoinForm(_ref) {
  var onSubmit = _ref.onSubmit,
    minHeight = _ref.minHeight,
    title = _ref.title,
    description = _ref.description;
  var spaceReg = /^(\w+\s?)*\s*$/; // ensures that only letters and space is allowed.
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var onNameChange = function onNameChange(event) {
    var value = event.target.value;
    if (spaceReg.test(value)) {
      value = value.replace(/^\s+/g, ''); // remove leading spaces
      value = value.replace(/\s\s+/g, ' '); // replace double spaces with single space
      setName(value);
    }
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var value = name.trim();
    onSubmit(value);
  };
  var buttonDisabled = true;
  if (name.trim()) {
    buttonDisabled = false;
  }
  return /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Wrapper, {
    $minHeight: minHeight
  }, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Title, null, title), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.Description, null, description), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledForm, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledLabel, {
    htmlFor: "name"
  }, "Name:"), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledInput, {
    placeholder: "Phillip Jenner",
    value: name,
    onChange: onNameChange,
    "data-testid": "name-input",
    id: "name",
    autoComplete: "name"
  }), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.TosWrapper, null, "By joining you agree to our", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://shoflo.tv/privacy/",
    target: "__blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "and", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://shoflo.tv/privacy/",
    target: "__blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"), "."), /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_StreamJoinForm.StyledJoinButton, {
    onClick: handleSubmit,
    disabled: buttonDisabled
  }, "Join"))));
};
StreamJoinForm.propTypes = {
  onSubmit: _propTypes.func.isRequired,
  minHeight: _propTypes.string,
  title: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired
};